import type { IElementConfig } from './types';

import { merge } from '../../helper';

import addClass from '../../general/class/addClass';
import child from '../../general/child';
import container from '../../general/container';
import newClass from '../../general/class/newClass';
import setAttrData from '../../general/attr/setAttrData';
import setDatasetData from '../../general/dataset/setDatasetData';
import setStyleData from '../../general/style/setStyleData';

import * as exEvent from '../event';

// ----------------------------------------------------------------------------

function create(config?: IElementConfig): HTMLElement {
    const defConfig: IElementConfig = {};
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Create element
    const element = document.createElement(defConfig.tag ?? 'div');

    // ------------------------------------------------------------------------

    // Settings
    settings(element, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return element;
}

function settings(element: HTMLElement, config: IElementConfig): void {
    // If using container
    if (config.container != null) {
        container(element, config.container);
    }

    // ------------------------------------------------------------------------

    // If using class
    if (config.class != null) {
        if (config.class.new != null) {
            newClass(element, config.class.new);
        }
        if (config.class.add != null) {
            addClass(element, config.class.add);
        }
    }

    // If using attribute
    if (config.attr != null) {
        setAttrData(element, config.attr);
    }

    // If using style
    if (config.style != null) {
        setStyleData(element, config.style);
    }

    // If using dataset
    if (config.dataset != null) {
        setDatasetData(element, config.dataset);
    }

    // ------------------------------------------------------------------------

    // If using html
    if (config.html != null) {
        child(element, config.html);
    }

    // ------------------------------------------------------------------------

    // If using event
    if (config.event != null) {
        exEvent.create(element, config.event);
    }
}

// ----------------------------------------------------------------------------

export default create;
